import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MusicService {

  private musicSubject$ = new BehaviorSubject<any>(null);
  private openMuisc$ = new BehaviorSubject<boolean>(null);
  musicSub$ = this.musicSubject$.asObservable();
  openMusicModal$ = this.openMuisc$.asObservable();
  constructor(private location: Location) {
    // Listen for popstate events
    window.addEventListener('popstate', () => {
      if (this.openMuisc$.value) {
        this.updateOpenMusicSub(false);
        // Push the state back to avoid navigation
        history.pushState(null, null, window.location.href);
      }
    });
  }

  updateMusicSub(data: any) : void {
    this.musicSubject$.next(data);
  }

  updateOpenMusicSub(data: boolean) : void {
    // if (data) {
    //   // Push a new state into the browser history only when opening the popup
    //   history.pushState(null, null, window.location.href);
    // }
    this.openMuisc$.next(data);
  }
}
